<template>
  <div class="preview-container w-e-text-container">
    <div class="preview-title">{{ title }}</div>
    <div v-html="html"></div>
  </div>
</template>

<script>
import api from '@/api/api.js'
import Vconsole from 'vconsole'
import unescapeHtml from '../../utils/unescapeHtml'

const isDev = process.env.NODE_ENV === 'development'

export default {
  title: '公告详情',

  name: 'detail',
  data() {
    return {
      html: '',
      title: '公告title',
      baseFontSize: 37.5,
    }
  },
  methods: {
    // px转rem的方法
    pxToRem(pxValue) {
      const px = parseFloat(pxValue)
      if (isNaN(px)) return pxValue
      return px / this.baseFontSize + 'rem'
    },

    // 转换HTML中的px单位为rem
    convertPxToRem(html) {
      // 处理style属性中的px单位
      let result = html.replace(/style="([^"]*?)"/g, (match, styleContent) => {
        // 替换各种CSS属性中的px值
        const convertedStyle = styleContent.replace(
          /(\d*\.?\d+)px/g,
          (pxMatch, pxValue) => {
            return this.pxToRem(pxValue)
          }
        )
        return `style="${convertedStyle}"`
      })

      // 处理width和height属性中的px单位
      result = result.replace(
        /(width|height)="(\d+\.?\d*)"/g,
        (match, attr, value) => {
          return `${attr}="${this.pxToRem(value)}"`
        }
      )

      return result
    },
    replaceContent(html) {
      const tableReg = /<table[^>]*style="[^"\n]*height:(\d+\.?\d*)(?=[;"'])/g
      let result = html.replace(tableReg, (match, heightValue) => {
        return match.replace(
          `height:${heightValue}`,
          `height:${heightValue}px`
        )
      })

      // 转换其他px单位为rem
      result = this.convertPxToRem(result)
      return result
    },

    handleContent(html) {
      html = unescapeHtml(html)
      this.html = this.replaceContent(html)
    },

    // 获取单个查询参数
    getQueryParam(key) {
      return this.$route.query[key]
    },

    getDetail() { 
      if (!this.code) {
        this.$message.error('缺少参数code')
        this.loading.close()
        return
      }
      api
        .getAnnounceDetail({ code: this.code })
        .then((res) => {
          if (res && res.ret === 200 && res.data) {
            this.title = res.data.name
            this.handleContent(res.data.content)
          } else {
            this.$message.error('获取公告详情异常')
          }
        })
        .catch((err) => {
          const _err = (err && err.msg) || '获取公告详情失败'
          this.$message.error(_err)
        })
        .finally(() => {
          this.loading.close()
        })
    },
    reportCount() {
      // 预览 不上报次数
      const isPreview = this.getQueryParam('preview')
      if (!this.code || isPreview) return
      api.reportAnnounceCount({
        code: this.code,
      })
    
    },
  },

  created() {
    this.code = this.getQueryParam('code')
    if (isDev) {
      const vConsole = new Vconsole()
      // vConsole.show()
    }
  },
  mounted() {
    this.loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.4)',
    })
    this.getDetail()
    this.reportCount()
  },
}
</script>

<style lang="less">
:host,
:root {
  --w-e-textarea-bg-color: #fff;
  --w-e-textarea-color: #333;
  --w-e-textarea-border-color: #ccc;
  --w-e-textarea-slight-border-color: #e8e8e8;
  --w-e-textarea-slight-color: #d4d4d4;
  --w-e-textarea-slight-bg-color: #f5f2f0;
  --w-e-textarea-selected-border-color: #b4d5ff;
  --w-e-textarea-handler-bg-color: #4290f7;
  --w-e-toolbar-color: #595959;
  --w-e-toolbar-bg-color: #fff;
  --w-e-toolbar-active-color: #333;
  --w-e-toolbar-active-bg-color: #f1f1f1;
  --w-e-toolbar-disabled-color: #999;
  --w-e-toolbar-border-color: #e8e8e8;
  --w-e-modal-button-bg-color: #fafafa;
  --w-e-modal-button-border-color: #d9d9d9;
}
.w-e-text-container *,
.w-e-toolbar * {
  box-sizing: border-box;
  margin: 0;
  outline: none;
  padding: 0;
}
.w-e-text-container blockquote,
.w-e-text-container li,
.w-e-text-container p,
.w-e-text-container td,
.w-e-text-container th,
.w-e-toolbar * {
  line-height: 1.5;
}
.w-e-text-container {
  background-color: var(--w-e-textarea-bg-color);
  color: var(--w-e-textarea-color);
  height: 100%;
  position: relative;
}
.no-scroll {
  width: 100%;
}
.w-e-text-container .w-e-scroll {
  height: 100%;
  -webkit-overflow-scrolling: touch;
}
.w-e-text-container {
  outline: 0;
  white-space: pre-wrap;
  word-wrap: break-word;
  border-top: 0.0267rem solid transparent;
  min-height: 100%;
  padding: 0 .64rem;
}

.preview-container.w-e-text-container {
  padding-bottom: .5333rem;
  padding-top: .4267rem;
}

.preview-container {
  text-align: justify;
  * {
    color: #5c606a;
    font-size: 0.4267rem;
  }
  .preview-title {
    font-size: 0.4267rem;
    line-height: 0.64rem;
    margin-bottom: 0.4267rem;
    font-weight: 500;
    color: #1a1d25;
  }
}

.preview-container img,
.preview-container video {
  max-width: 100%;
}
.w-e-text-container img,
.w-e-text-container video {
  cursor: default;
  display: inline !important;
  max-width: 100%;
  min-height: 0.5333rem;
  min-width: 0.5333rem;
}

.w-e-text-container ul,
.w-e-text-container ol {
  margin-left: 0.2667rem;
}

.w-e-max-length-info,
.w-e-text-placeholder {
  color: var(--w-e-textarea-slight-color);
  pointer-events: none;
  position: absolute;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}
.w-e-max-length-info {
  bottom: 0.5em;
  right: 1em;
}

.w-e-text-container blockquote,
.w-e-text-container li,
.w-e-text-container p,
.w-e-text-container td,
.w-e-text-container th,
.w-e-toolbar * {
  line-height: 1.5;
}

.no-scroll {
  width: 100%;
}

.w-e-text-container p {
  margin: 0.2667rem 0;
}

.w-e-text-container img {
  cursor: default;
  display: inline !important;
  max-width: 100%;
  min-height: 0.5333rem;
  min-width: 0.5333rem;
}
.w-e-text-container span {
  text-indent: 0;
}
.w-e-text-container [data-selected="true"] {
  box-shadow: 0 0 0 0.0533rem var(--w-e-textarea-selected-border-color);
}
.w-e-text-placeholder {
  font-style: italic;
  left: 0.2667rem;
  top: 0.4533rem;
  width: 90%;
}

.w-e-hover-bar {
  border: 0.0267rem solid var(--w-e-toolbar-border-color);
  border-radius: 0.08rem;
  box-shadow: 0 0.0533rem 0.1333rem #0000001f;
  position: absolute;
}
.w-e-toolbar {
  flex-wrap: wrap;
  position: relative;
}

.w-e-textarea-divider {
  border-radius: 0.08rem;
  margin: 0.5333rem auto;
  padding: 0.5333rem;
}
.w-e-textarea-divider hr {
  background-color: var(--w-e-textarea-border-color);
  border: 0;
  display: block;
  height: 0.0267rem;
  margin: 0.2667rem 0;
}
.w-e-text-container pre > code {
  background-color: var(--w-e-textarea-slight-bg-color);
  border: 0.0267rem solid var(--w-e-textarea-slight-border-color);
  border-radius: 0.1067rem 0.1067rem;
  display: block;
  font-size: 0.3733rem;
  padding: 0.2667rem;
  text-indent: 0;
}
.w-e-text-container .w-e-image-container {
  display: inline-block;
  margin: 0 0.08rem;
}
.w-e-text-container .w-e-image-container:hover {
  box-shadow: 0 0 0 0.0533rem var(--w-e-textarea-selected-border-color);
}
.w-e-text-container .w-e-selected-image-container {
  overflow: hidden;
  position: relative;
}
.w-e-text-container .w-e-selected-image-container .w-e-image-dragger {
  background-color: var(--w-e-textarea-handler-bg-color);
  height: 0.1867rem;
  position: absolute;
  width: 0.1867rem;
}
.w-e-text-container .w-e-selected-image-container .left-top {
  cursor: nwse-resize;
  left: 0;
  top: 0;
}
.w-e-text-container .w-e-selected-image-container .right-top {
  cursor: nesw-resize;
  right: 0;
  top: 0;
}
.w-e-text-container .w-e-selected-image-container .left-bottom {
  bottom: 0;
  cursor: nesw-resize;
  left: 0;
}
.w-e-text-container .w-e-selected-image-container .right-bottom {
  bottom: 0;
  cursor: nwse-resize;
  right: 0;
}
.w-e-text-container [contenteditable="false"] .w-e-image-container:hover,
.w-e-text-container .w-e-selected-image-container:hover {
  box-shadow: none;
}
.w-e-text-container code {
  background-color: var(--w-e-textarea-slight-bg-color);
  border-radius: 0.08rem;
  font-family: monospace;
  padding: 0.08rem;
}

.w-e-text-container blockquote {
  background-color: var(--w-e-textarea-slight-bg-color);
  border-left: 0.2133rem solid var(--w-e-textarea-selected-border-color);
  display: block;
  font-size: 100%;
  line-height: 1.5;
  margin: 0.2667rem 0;
  padding: 0.2667rem;
}

.w-e-text-container hr {
  background-color: var(--w-e-textarea-border-color);
  border: 0;
  display: block;
  height: 0.02667rem;
  margin: 0.2667rem 0;
}

.w-e-text-container .table-container {
  border-radius: 0;
  margin-top: 0.2667rem;
  overflow-x: auto;
  padding: 0;
  position: relative;
  width: 100%;
}
.w-e-text-container table {
  border-collapse: collapse;
  table-layout: fixed;
}
.w-e-text-container table td,
.w-e-text-container table th {
  border: 0.0267rem solid var(--w-e-textarea-border-color);
  line-height: 1.5;
  min-width: 0.8rem;
  overflow: hidden;
  overflow-wrap: break-word;
  padding: 0.08rem 0.1333rem;
  white-space: pre-wrap;
  word-break: break-all;
  min-height: 0.5333rem;
}
.w-e-text-container table th {
  background-color: var(--w-e-textarea-slight-bg-color);
  font-weight: 700;
  text-align: center;
}
.w-e-text-container table td.w-e-selected,
.w-e-text-container table th.w-e-selected {
  background-color: rgba(20, 86, 240, 0.18);
}
.w-e-text-container table.table-selection-none ::-moz-selection {
  background: none;
}
.w-e-text-container table.table-selection-none ::selection {
  background: none;
}
.w-e-text-container .column-resizer {
  display: flex;
  height: 0;
  left: 0;
  position: absolute;
  top: 0;
  width: 0;
  z-index: 1;
}
.w-e-text-container .column-resizer .column-resizer-item {
  position: relative;
}
.w-e-text-container .resizer-line-hotzone {
  cursor: col-resize;
  opacity: 0;
  position: absolute;
  right: 0;
  transition: opacity 0.2s ease, visibility 0.2s ease;
  visibility: hidden;
  width: 0.16rem;
}
.w-e-text-container .resizer-line-hotzone .resizer-line {
  background: rgba(20, 86, 240, 0.8);
  height: 100%;
  margin-left: 0.1333rem;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  width: 0.0533rem;
}
.w-e-text-container .resizer-line-hotzone.visible {
  visibility: visible;
}
.w-e-text-container .resizer-line-hotzone.highlight {
  opacity: 1;
}
.w-e-panel-content-table {
  background-color: var(--w-e-toolbar-bg-color);
}
.w-e-panel-content-table table {
  border-collapse: collapse;
  table-layout: fixed;
}
.w-e-panel-content-table td,
.w-e-panel-content-table th {
  overflow: hidden;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  word-break: break-all;
}
.w-e-panel-content-table td {
  border: 0.0267rem solid var(--w-e-toolbar-border-color);
  cursor: pointer;
  //   height: .4rem;
  padding: 0.08rem 0.1333rem;
  width: 0.5333rem;
}
.w-e-panel-content-table td.active {
  background-color: var(--w-e-toolbar-active-bg-color);
}

.w-e-textarea-video-container {
  background-image: linear-gradient(
      45deg,
      #eee 25%,
      transparent 0,
      transparent 75%,
      #eee 0,
      #eee
    ),
    linear-gradient(45deg, #eee 25%, #fff 0, #fff 75%, #eee 0, #eee);
  background-position: 0 0, 0.2667rem 0.2667rem;
  background-size: 0.5333rem 0.5333rem;
  border: 0.0267rem dashed var(--w-e-textarea-border-color);
  border-radius: 0.1333rem;
  margin: 0.2667rem auto 0;
  overflow: auto;
  padding: 0.2667rem 0;
  text-align: center;
}

.w-e-text-container pre > code {
  font-family: Consolas, Monaco, Andale Mono, Ubuntu Mono, monospace;
  text-align: left;
  text-shadow: 0 0.0267rem #fff;
  white-space: pre;
  word-break: normal;
  word-spacing: normal;
  word-wrap: normal;
  hyphens: none;
  line-height: 1.5;
  margin: 0.5em 0;
  overflow: auto;
  padding: 1em;
  -moz-tab-size: 4;
  -o-tab-size: 4;
  tab-size: 4;
}
.w-e-text-container pre > code .token.cdata,
.w-e-text-container pre > code .token.comment,
.w-e-text-container pre > code .token.doctype,
.w-e-text-container pre > code .token.prolog {
  color: #708090;
}
.w-e-text-container pre > code .token.punctuation {
  color: #999;
}
.w-e-text-container pre > code .token.namespace {
  opacity: 0.7;
}
.w-e-text-container pre > code .token.boolean,
.w-e-text-container pre > code .token.constant,
.w-e-text-container pre > code .token.deleted,
.w-e-text-container pre > code .token.number,
.w-e-text-container pre > code .token.property,
.w-e-text-container pre > code .token.symbol,
.w-e-text-container pre > code .token.tag {
  color: #905;
}
.w-e-text-container pre > code .token.attr-name,
.w-e-text-container pre > code .token.builtin,
.w-e-text-container pre > code .token.char,
.w-e-text-container pre > code .token.inserted,
.w-e-text-container pre > code .token.selector,
.w-e-text-container pre > code .token.string {
  color: #690;
}
.w-e-text-container pre > code .language-css .token.string,
.w-e-text-container pre > code .style .token.string,
.w-e-text-container pre > code .token.entity,
.w-e-text-container pre > code .token.operator,
.w-e-text-container pre > code .token.url {
  color: #9a6e3a;
}
.w-e-text-container pre > code .token.atrule,
.w-e-text-container pre > code .token.attr-value,
.w-e-text-container pre > code .token.keyword {
  color: #07a;
}
.w-e-text-container pre > code .token.class-name,
.w-e-text-container pre > code .token.function {
  color: #dd4a68;
}
.w-e-text-container pre > code .token.important,
.w-e-text-container pre > code .token.regex,
.w-e-text-container pre > code .token.variable {
  color: #e90;
}
.w-e-text-container pre > code .token.bold,
.w-e-text-container pre > code .token.important {
  font-weight: 700;
}
.w-e-text-container pre > code .token.italic {
  font-style: italic;
}
.w-e-text-container pre > code .token.entity {
  cursor: help;
}
</style>
